<template>
  <div>
    <span>&nbsp;</span>
    <div class="container">
      <div class="form-group">
        <div class="input-group input-group-mb3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-lg">Location</span>
          </div>
          <gmap-autocomplete
            class="form-control"
            placeholder="Current (or address)"
            @place_changed="setPlace"
          ></gmap-autocomplete>
          <!--<input type="text" class="form-control" aria-label="radius in kilometers" aria-describedby="inputGroup-sizing-lg" v-model="radius" @change="getRetailers()">-->
        </div>
        <div class="input-group input-group-mb3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-lg">Distance (km)</span>
          </div>
          <input
            type="text"
            class="form-control"
            aria-label="radius in kilometers"
            aria-describedby="inputGroup-sizing-lg"
            v-model="radius"
            @change="getRetailers()"
          />
        </div>
        <div class="input-group input-group-mb3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-lg">Wine Varietal</span>
          </div>
          <select
            class="custom-select"
            id="inputGroupSelect01"
            v-model="varietal"
            @change="getRetailers()"
          >
            <option selected value="ALL">All Wines</option>
            <option v-for="varietal in varietals" v-bind:key="varietal">{{ varietal }}</option>
          </select>
        </div>
        <p />
        <p />
      </div>
    </div>
    <div class="container-fluid">
      <gmap-map :center="center" :zoom="14" style="max-width: 100%; height: 75vh;">
        <gmap-info-window
          :opened="infoWinOpen"
          :options="infoOptions"
          :position="infoWindowPos"
          @closeclick="infoWinOpen=false"
        >
          <div v-html="infoContent"></div>
        </gmap-info-window>
        <!--<gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" :label="m.aMarker.name" @click="toggleInfoWindow(m, index)">-->
        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          @click="toggleInfoWindow(m, index)"
        ></gmap-marker>
      </gmap-map>
    </div>
    <span>&nbsp;</span>
  </div>
</template>
        
<script>
import axios from "axios";

const debug = process.env.NODE_ENV !== "production";

export default {
  name: "GoogleMap",
  data() {
    return {
      //default to DLV Winery to keep it simple
      center: { lat: 49.5661602, lng: -119.6648164 },
      markers: [],
      places: [],
      currentPlace: null,
      retailers: [],
      varietals: [],
      infoContent: "",
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      show: true,
      radius: 10,
      varietal: "ALL",
      showSpinner: true,
      errorCode: {}
    };
  },
  mounted() {
    this.geolocate();
    this.getVarietals();
  },
  methods: {
    // receives a place object via the autocomplete component
    setPlace(place) {
      this.currentPlace = place;
      const marker = {
        lat: this.currentPlace.geometry.location.lat(),
        lng: this.currentPlace.geometry.location.lng()
      };
      this.center = marker;
      this.getRetailers();
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        const currentMarker = {
          name: "Added Pin",
          street1: this.currentPlace.formatted_address,
          phone1: ""
        };
        this.markers.push({ position: marker, aMarker: currentMarker });
        this.places.push(this.currentPlace);
        this.center = marker;
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(
        position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.getRetailers();
        },
        error => {
          this.errorCode = error;
          this.$parent.visible = false;
        }
      );
    },
    getRetailers() {
      if (debug) {
        var API_PATH = "http://192.168.20.124:8000/api/customers";
      } else {
        API_PATH = "https://dlvmgmt.dirtylaundry.ca/api/customers";
      }
      this.$parent.visible = true;
      axios
        .get(API_PATH, {
          headers: {
            "content-type": "application/json"
          },
          params: {
            radius: this.radius,
            latitude: this.center.lat,
            longitude: this.center.lng,
            varietal: this.varietal
          }
        })
        .then(response => {
          this.retailers = response.data;
          this.markers = [];
          for (var retailer of this.retailers) {
            const marker = {
              lat: Number(retailer.fields.latitude),
              lng: Number(retailer.fields.longitude)
            };

            this.markers.push({ position: marker, aMarker: retailer.fields });
          }
          this.$parent.visible = false;
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
    getVarietals() {
      if (debug) {
        var API_PATH = "http://192.168.20.124:8000/api/varietals/";
      } else {
        API_PATH = "https://dlvmgmt.dirtylaundry.ca/api/varietals/";
      }
      axios
        .get(API_PATH, {
          headers: {
            "content-type": "application/json"
          }
        })
        .then(response => {
          this.varietals = response.data;
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
    toggleInfoWindow: function(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = this.getInfoWindowContent(marker);

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    getInfoWindowContent: function(marker) {
      return `<div class="card">
            <div class="card-content">
                <div class="media">
                <div class="media-content">
                    <p class="title">${marker.aMarker.name}</p>
                </div>
                </div>
                <div class="content">
                ${marker.aMarker.street1}
                <br>
                ${marker.aMarker.phone1}
                <br />
                <br>
                <strong><a href="http://maps.google.com/maps?saddr=${this.center.lat},${this.center.lng}&daddr=${marker.position.lat},${marker.position.lng}" title="Get Driving Directions" target="_blank">Get Directions</a></strong>
                </div>
            </div>
            </div>`;
    },
    onSubmit(evt) {
      evt.preventDefault();
      //alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>

<style>
.title {
  font-size: 1.5em;
  font-weight: bold;
}
.input-group > .input-group-prepend {
  flex: 0 0 43%;
}
.input-group .input-group-text {
  width: 100%;
  background-color: #5d0a0a;
  color: #fff0c1;
  border: 0;
}
.card {
  border: none;
}
.form-control {
  border: 0;
  background-color: #fff0c1;
}
.custom-select {
  border: 0;
  background-color: #fff0c1;
}
.btn {
  color: #ffffff;
  background: linear-gradient(#dcdcdc, #555555);
  border: 0;
}
.btn:hover {
  color: #ffffff;
  background: linear-gradient(#ff0004, #680204);
}
</style>